(function () {
  'use strict';

  angular.module('sempraWebapp').factory('NewsViewModel', NewsViewModelFactory);

  /** @ngInject */
  function NewsViewModelFactory (DateTime, $translate, sessionData) {
    function NewsViewModel () {
      init.call(this);

      this.companyId = 3;

      // FACILITIES
      this.facilities = [];
      this.selectedFacilities = [{name: $translate.instant('ALL_FACILITIES'), id:-1}];

      // NEWS
      this.newsCreated = new Date();

      this.newsText  = '';
      this.newsTitle = '';
      this.newsLanguage = sessionData.getValue(sessionData.Keys.LANGUAGE_KEY) || 'asd';

      // GRID CONFIG
      this.newsData = [];
      this.newsOrderBy = 'content';
      this.newsOrder = 'asc';
      this.newsPage = 1;
      this.newsTotal = 0;
      this.newsPageSize = 10;
      this.newsPageOptions = [5, 10, 15];
      this.selectedNews = [];
      this.pagerTranslations = {
          page: $translate.instant('GRID_PAGER_PAGE'),
          rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
          of: $translate.instant('GRID_PAGER_PAGE_OF')
      };
    }

    NewsViewModel.prototype.destroy = function () {

    };

    NewsViewModel.prototype.refreshData = function (data) {
      this.newsData = [];
      this.newsData = data.content;
      this.newsTotal = data.totalElements;
    };

    NewsViewModel.prototype.newsSortChanged = function(order){
      var orderQuery = getOrderObject(order);
      this.newsOrderBy = orderQuery.orderBy;
      this.newsOrder = orderQuery.order;
    };

    NewsViewModel.prototype.newsPaginationChanged = function(page, limit){
      this.newsPage = page;
      this.newsPageSize = limit;
    };

    // helper function
    function getOrderObject(order) {
        var result = {
            order: 'asc',
            orderBy: order
        };

        if (order.indexOf('-') > -1) {
            result.order = 'desc';
            result.orderBy = order.substring(1);
        }
        return result;
    }


    return NewsViewModel;

    function init () {

    }

  }
})();
